<nes-asset
  class="nes-fixed nes-inset-0 nes-w-screen nes-h-screen nes-z-0 nes-rotate-180"
  color="secondary-default"
  name="flow-gradient"
  resize="nes-w-screen nes-h-screen"
>
</nes-asset>

<zkh-message-toast></zkh-message-toast>

<nes-section spacing="tight" class="nes-relative nes-z-10">
  <div class="adviced-product-explanation nes-mb-24">
    <nes-text transform="uppercase" size="200" color="text-inverse-subdued">{{
      "ADVICE.OUR_ADVICE" | translate
    }}</nes-text>
    <h2
      class="nes-hidden lg:nes-inline-block nes-mb-5 nes-text-1200 nes-font-bold nes-text-inverse-subdued"
    >
      {{ explanationHeader | translate }}
    </h2>
    <h2
      class="nes-inline-block lg:nes-hidden nes-mb-5 nes-text-1200 nes-font-bold nes-text-inverse-subdued"
    >
      {{ explanationHeaderMobile | translate }}
    </h2>
    <nes-text class="nes-max-w-prose nes-mb-5" color="text-inverse-subdued">
      {{ explanationText | translate }}
    </nes-text>
  </div>

  <app-explanation-tile
    [isMobileView]="isMobileView"
    [advicedProduct]="advicedProduct"
    (orderProduct)="orderProduct($event)"
  ></app-explanation-tile>

  <app-advice-build-up
    (requestContact)="requestContact()"
  ></app-advice-build-up>

  <app-ketendiensten></app-ketendiensten>

  <app-system-coupling
    [isMobileView]="isMobileView"
    [advicedProduct]="advicedProduct"
  ></app-system-coupling>

  <app-product-comparison
    [isMobileView]="isMobileView"
    [allProducts]="allProducts"
    [featureGroups]="featureGroups"
    [advicedProduct]="advicedProduct"
    (orderProduct)="orderProduct($event)"
  ></app-product-comparison>

  <app-businesscase
    [isMobileView]="isMobileView"
    (shareAdviceLink)="shareAdviceLink()"
    (requestContact)="requestContact()"
  ></app-businesscase>

  <app-customer-reference
    [isMobileView]="isMobileView"
    [advicedProduct]="advicedProduct"
  ></app-customer-reference>

  <app-advice-footer
    [isMobileView]="isMobileView"
    (orderProduct)="orderProduct($event)"
    [advicedProduct]="advicedProduct"
  ></app-advice-footer>

</nes-section>
